import classnames from 'classnames';
import React from 'react';

/**
 * Base dialog overlay provides the opaque dark grey color on top of the app.
 * Tabindex is intentionally set to -1 as it should never be interacted with.
 * @param props DialogOverlayProps
 */ const DialogOverlay = (props)=>{
    const { className, size, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-dialog__overlay': true,
            [`bf-dialog__overlay--size-${size}`]: size,
            [`${className}`]: !!className
        }),
        role: "presentation",
        tabIndex: -1
    });
};

export { DialogOverlay };
//# sourceMappingURL=dialog-overlay.js.map
